import { saveHubwayzPendingPaymentOrder } from "../../../services/hubwayzHotelsApi";
import { buildHotelOrderPaymentPath } from "../../../utils/orders/resolveHotelSuccessNavigation";
import { buildHubwayzOfficialBookPayload } from "./buildHubwayzOfficialBookPayload";

const PAY_LATER_BLOCKED =
  "שריון ללא תשלום חסום זמנית עד להחלטה על מדיניות השריון.";

/**
 * Save an unpaid internal order and open /payment/:orderId.
 * Does not call the supplier Book.
 */
export async function continueHubwayzHotelToPayment(input = {}, deps = {}) {
  if (input.paymentIntent === "pay_later") {
    return {
      ok: false,
      code: "pay_later_blocked",
      supplierBook: false,
      message: PAY_LATER_BLOCKED,
    };
  }
  const draft = input.draft || {};
  const prebookNormalized = input.prebookNormalized || draft.prebook?.normalized || null;
  const token = String(
    prebookNormalized?.display?.token || draft.prebook?.token || ""
  ).trim();
  const build = deps.payloadBuilder || buildHubwayzOfficialBookPayload;
  const built = build({
    offerCode: draft.hubwayzOfferCode,
    token,
    searchRequest: draft.searchRequest,
    prebookNormalized,
    prebookRaw: draft.prebook?.raw || null,
    passengers: draft.passengers || input.passengers || [],
    appliedSearch: input.appliedSearch || null,
    customer: draft.hubwayzCustomer,
    reference: {
      agency: `pay-${draft.packageId || draft.hubwayzOfferCode || "hotel"}`.slice(0, 32),
      voucherEmail: draft.hubwayzCustomer?.contact?.email || undefined,
    },
    paymentMethodName: "account_credit",
    paxFallback: Number(draft.paxCount) || 2,
  });
  if (!built?.ok || !built.payload) {
    return {
      ok: false,
      code: built?.error?.code || "book_payload_invalid",
      supplierBook: false,
      message: built?.error?.message || "לא נשמרה הזמנה פנימית. לא נשלחה הזמנה לספק.",
    };
  }
  const save = deps.saveClient || saveHubwayzPendingPaymentOrder;
  let saved;
  try {
    saved = await save({
      searchId:
        draft.hubwayzSearchId ||
        draft.hubwayzVerifiedQuote?.searchId ||
        draft.searchRequest?.searchId ||
        draft.searchId ||
        "",
      hotelName: draft.hotelName || "",
      displayCurrency: draft.displayCurrency || null,
      commissionType: draft.agentCommissionType || null,
      commissionValue: draft.agentCommissionValue ?? null,
      payload: built.payload,
    });
  } catch (err) {
    return {
      ok: false,
      code: "pending_order_failed",
      supplierBook: false,
      message: "לא נשמרה הזמנה פנימית. לא נשלחה הזמנה לספק.",
    };
  }
  const orderId = saved?.order_id ?? saved?.orderId;
  const path = buildHotelOrderPaymentPath({ order_id: orderId });
  if (!saved?.ok || !path) {
    return {
      ok: false,
      code: saved?.status || "pending_order_failed",
      supplierBook: false,
      message: saved?.message || saved?.error || "לא נשמרה הזמנה פנימית. לא נשלחה הזמנה לספק.",
    };
  }
  return {
    ok: true,
    supplierBook: false,
    orderId,
    path,
  };
}
